module.exports = __webpack_public_path__ + "img/llttx.b4304037.png";